// extracted by mini-css-extract-plugin
module.exports = {"popUp":"popUp_popUp__1Yv4g"};